import { useState } from "react";
import { login as loginController } from "../../services/authService.js";
import Input from "../tags/Input.jsx";
import Button from "../tags/Button.jsx";
import { showErrorToast, showPromiseToast } from "../../services/toastService.js";
import { useAuth } from "../../contexts/AuthContextProvider.jsx";

export default function LoginModal({ close }) {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [rememberMe, setRememberMe] = useState(true);
	const { login } = useAuth();

	// Validazione dei campi
	const validateFields = () => {
		if (!username.trim() || !password.trim()) {
			showErrorToast("Entrambi i campi sono obbligatori.");
			return false;
		}
		return true;
	};

	// Gestione del login
	const loginHandler = async () => {
		if (!validateFields()) return;
		showPromiseToast(loginController(username, password, rememberMe), {
			pending: "Accesso in corso...",
			success: "Accesso effettuato!",
		})
			.then((res) => {
				login(res.data.accessToken, res.data.refreshToken, res.data.user);
				close();
			})
			.catch((err) => showErrorToast("Errore durante il login"));
	};

	return (
		<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
			<div className="bg-white rounded-lg shadow-lg p-6 w-96 relative">
				{/* Titolo del modal */}
				<h2 className="text-xl font-bold text-blue-700 mb-4 text-center">Accedi</h2>

				{/* Campi di input */}
				<div className="space-y-4">
					<Input
						label={"Username"}
						value={username}
						onChange={(value) => setUsername(value)}
						placeholder={`Inserisci il tuo username`}
					/>
					<Input
						label={"Password"}
						value={password}
						onChange={(value) => setPassword(value)}
						placeholder={`Inserisci la tua password`}
						type={"password"}
					/>
				</div>

				{/* Checkbox Ricordami */}
				<div className="mt-4 flex items-center">
					<input
						type="checkbox"
						id="rememberMe"
						checked={rememberMe}
						onChange={(e) => setRememberMe(e.target.checked)}
						className="mr-2"
					/>
					<label htmlFor="rememberMe" className="text-gray-700">
						Ricordami
					</label>
				</div>

				{/* Pulsante per il login */}
				<div className="mt-6">
					<Button
						primary
						rounded
						className="bg-blue-700 text-white hover:bg-blue-800 transition"
						onClick={loginHandler}
					>
						Accedi
					</Button>
				</div>
			</div>
		</div>
	);
}
